import { SxProps, Theme } from '@mui/material';

/** Hero two-column wrapper (only rendered when `heading` prop is provided) */
export const heroWrapperStyles: SxProps<Theme> = {
	display: 'flex',
	flexDirection: { xs: 'column', md: 'row' },
	alignItems: { xs: 'stretch', md: 'center' },
	justifyContent: 'space-between',
	gap: { xs: 4, md: 8 },
	px: { xs: 3, md: 10 },
	py: { xs: 6, md: 10 },
	width: '100%',
};

export const heroContentStyles: SxProps<Theme> = {
	display: 'flex',
	flexDirection: 'column',
	gap: 3,
	flex: 1,
	color: 'common.white',
};

export const heroEyebrowStyles: SxProps<Theme> = {
	typography: 'bodyMediumBook',
	color: 'common.white',
};

export const heroHeadingStyles: SxProps<Theme> = {
	typography: { xs: 'header3', md: 'display2' },
	color: 'common.white',
};

export const heroDescriptionStyles: SxProps<Theme> = {
	typography: 'bodyLargeBook',
	color: 'common.white',
};

export const heroPhoneStyles: SxProps<Theme> = {
	display: 'flex',
	alignItems: 'center',
	gap: 1,
	typography: 'bodyLargeBook',
	color: 'common.white',
};

export const formCardStyles: SxProps<Theme> = {
	backgroundColor: 'white',
	borderRadius: '1rem',
	padding: { xs: '2rem 1.5rem', md: '3rem 2.5rem' },
	display: 'flex',
	flexDirection: 'column',
	gap: 2,
	width: { xs: '100%', md: '480px' },
	flexShrink: 0,
	boxShadow: '0px 4px 24px rgba(0, 0, 0, 0.12)',
};

export const formTitleStyles: SxProps<Theme> = {
	fontFamily: 'Beausite Classic',
	fontSize: { xs: '1.75rem', md: '2rem' },
	fontWeight: 500,
	color: '#0A2F54',
	lineHeight: 1.3,
	mb: 1,
};

export const fieldStyles: SxProps<Theme> = {
	width: '100%',
};

export const scheduleButtonStyles: SxProps<Theme> = {
	alignSelf: 'flex-end',
	mt: 1,
	padding: '0.875rem 2rem',
	fontWeight: 400,
	textTransform: 'none',
	fontSize: '1rem',
	borderRadius: '2rem',
	backgroundColor: '#E89B4C',
	color: '#0A2F54',
	fontFamily: 'Beausite Classic',
	boxShadow: 'none',
	'&:hover': {
		backgroundColor: '#D88A3B',
		boxShadow: 'none',
	},
	'&:active': {
		boxShadow: 'none',
	},
	'&.Mui-disabled': {
		backgroundColor: '#D1D9E2',
		color: '#8A9BAD',
		boxShadow: 'none',
	},
};
